import { useEffect } from "react";
import { navigate } from "gatsby";
import browserLang from "browser-lang";

const LOCAL_STORAGE_KEY = "language";
const DEFAULT_LOCALE = "en";

export const setPreferredLocale = newLocale => {
  console.log(`Preferred locale set to ${newLocale}`);
  window.localStorage.setItem(LOCAL_STORAGE_KEY, newLocale);
};

export const getPreferredLocale = () =>
  window.localStorage.getItem(LOCAL_STORAGE_KEY);

const Redirect = ({ locale: current, locales }) => {
  useEffect(() => {
    // Skip build, the code should only run on browser side only
    if (typeof window !== "undefined") {
      let preferred = getPreferredLocale();
      const detected = browserLang({
        languages: ["en", "fr", "de", "ja"],
        fallback: DEFAULT_LOCALE,
      });

      if (!preferred && current === "en") {
        // Make detection only if on the default 'en' page.
        console.log(`Default locale set to browser lang: ${detected}`);
        preferred = detected;
        setPreferredLocale(preferred);
      }

      if (preferred && current !== preferred) {
        // Redirect to the corresponding localized url
        let path;
        locales.forEach(element => {
          if (element.locale === preferred) {
            path = element.path + window.location.search;
          }
        });

        if (path) {
          navigate(path);
        }
      }
    }
  }, [current, locales]);
  return null;
};

export default Redirect;